import MDEditor from '@uiw/react-md-editor';
import { ChangeEvent, ChangeEventHandler, ReactElement, useState } from 'react';
interface EditableMarkdownProps {
  label: string;
  id: string;
  value: string;
  changeEvent: ChangeEventHandler<HTMLTextAreaElement>;
  error?: string;
  isDisabled?: boolean;
  placeholder?: string;
}
const EditableMarkdown = ({
  label,
  id,
  value,
  changeEvent,
  error,
  isDisabled = false,
  placeholder
}: EditableMarkdownProps): ReactElement => {
  const [showError, setShowError] = useState(false);
  const handleMouseEnter = (): void => {
    if (error) setShowError(true);
  };
  const handleMouseLeave = (): void => {
    setShowError(false);
  };
  const handleMarkdownChange = (val?: string): void => {
    const event = {
      target: {
        id: id,
        value: val || ''
      }
    } as ChangeEvent<HTMLTextAreaElement>;
    changeEvent(event);
  };
  return <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={`input-wrapper`} data-sentry-component="EditableMarkdown" data-sentry-source-file="EditableMarkdown.tsx">
      <label htmlFor={id}>{label}</label>
      <div data-color-mode='light'>
        <MDEditor className={error ? 'border-2 border-rose-500' : ''} id={id} value={value} onChange={handleMarkdownChange} preview='edit' textareaProps={{
        disabled: isDisabled
      }} placeholder={placeholder} data-sentry-element="MDEditor" data-sentry-source-file="EditableMarkdown.tsx" />
        {showError && error && <p className='text-red-500 text-sm'>{error}</p>}
      </div>
    </div>;
};
export default EditableMarkdown;